/*
 *  Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import {
  APPLICATION_STATUS_ACCUSATION,
  APPLICATION_STATUS_ACCUSATION_OTHER,
  APPLICATION_STATUS_AUTHORITY_NOTIFICATION,
  APPLICATION_STATUS_DAMAGE,
  APPLICATION_STATUS_DISTANCE,
  APPLICATION_STATUS_DOCUMENT_CHOICE,
  APPLICATION_STATUS_DOCUMENTS,
  APPLICATION_STATUS_DONE,
  APPLICATION_STATUS_DRIVERS_LICENSE_INDISPENSABLE,
  APPLICATION_STATUS_DRIVERS_LICENSE_PERIOD,
  APPLICATION_STATUS_FLASHED,
  APPLICATION_STATUS_FLENSBURG_POINTS,
  APPLICATION_STATUS_LEGAL_INSURANCE,
  APPLICATION_STATUS_LOCALITY,
  APPLICATION_STATUS_PERSONAL_DATA,
  APPLICATION_STATUS_POWER_OF_ATTORNEY,
  APPLICATION_STATUS_RED_LIGHT,
  APPLICATION_STATUS_ROAD_USERS_ENDANGERED,
  APPLICATION_STATUS_SPEED,
  APPLICATION_STATUS_SPEEDING,
  APPLICATION_STATUS_VEHICLE,
} from "./applicationStatus";
import React from "react";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import progressBarSteps from "./progressBarSteps";
import Accusation from "../../components/Form/Traffic/Accusation";
import DriversLicensePeriod from "../../components/Form/Traffic/DriversLicensePeriod";
import Flensburg from "../../components/Form/Traffic/Flensburg";
import Flashed from "../../components/Form/Traffic/Flashed";
import Indispensable from "../../components/Form/Traffic/Indispensable";
import AuthorityNotification from "../../components/Form/Traffic/AuthorityNotification";
import Petitioner from "../../components/Form/Traffic/Petitioner";
import SpeedingLocality from "../../components/Form/Traffic/SpeedingLocality";
import SpeedingSpeed from "../../components/Form/Traffic/SpeedingSpeed";
import RoadUsersEndangered from "../../components/Form/Traffic/RoadUsersEndangered";
import Damage from "../../components/Form/Traffic/Damage";
import RedLight from "../../components/Form/Traffic/RedLight";
import DistanceSpeed from "../../components/Form/Traffic/DistanceSpeed";
import Distance from "../../components/Form/Traffic/Distance";
import AccusationOther from "../../components/Form/Traffic/AccusationOther";
import MobileVehicle from "../../components/Form/Traffic/MobileVehicle";
import DocumentChoice from "../../components/Form/Traffic/DocumentChoice";
import PowerOfAttorney from "../../components/Form/Traffic/PowerOfAttorney";
import { getCaseLink } from "../productService";
import { Navigate } from "react-router-dom";
import Insurance from "../../components/Form/Common/Insurance/Insurance";
import { FormSteps } from "../../types/FormServiceBase";
import Documents from "../../components/Form/Traffic/Documents";

const formSteps: FormSteps = {
  [APPLICATION_STATUS_ACCUSATION]: {
    title: "Antrag - Vorwurf | Legalbird",
    stepUrl: "vorwurf",
    applicationStatus: APPLICATION_STATUS_ACCUSATION,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"accusation"} progress={16} />
        <Accusation {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_AUTHORITY_NOTIFICATION]: {
    title: "Antrag - Schreiben | Legalbird",
    stepUrl: "schreiben",
    applicationStatus: APPLICATION_STATUS_AUTHORITY_NOTIFICATION,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"accusation"} progress={33} />
        <AuthorityNotification {...props} />
      </>
    ),
  },
  //-- speeding
  [APPLICATION_STATUS_LOCALITY]: {
    title: "Antrag - Ort | Legalbird",
    stepUrl: "ort",
    applicationStatus: APPLICATION_STATUS_LOCALITY,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"accusation"} progress={40} />
        <SpeedingLocality {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_SPEEDING]: {
    title: "Antrag - Geschwindigkeit | Legalbird",
    stepUrl: "geschwindigkeit",
    applicationStatus: APPLICATION_STATUS_SPEEDING,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"accusation"} progress={45} />
        <SpeedingSpeed {...props} />
      </>
    ),
  },
  //-- traffic light
  [APPLICATION_STATUS_ROAD_USERS_ENDANGERED]: {
    title: "Antrag - Verkehrsteilnehmer gefährdet | Legalbird",
    stepUrl: "verkehrsteilnehmer",
    applicationStatus: APPLICATION_STATUS_ROAD_USERS_ENDANGERED,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"accusation"} progress={43} />
        <RoadUsersEndangered {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_DAMAGE]: {
    title: "Antrag - Beschädigungen | Legalbird",
    stepUrl: "beschaedigungen",
    applicationStatus: APPLICATION_STATUS_DAMAGE,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"accusation"} progress={46} />
        <Damage {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_RED_LIGHT]: {
    title: "Antrag - Ampel | Legalbird",
    stepUrl: "ampel",
    applicationStatus: APPLICATION_STATUS_RED_LIGHT,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"accusation"} progress={49} />
        <RedLight {...props} />
      </>
    ),
  },
  //-- distance
  [APPLICATION_STATUS_SPEED]: {
    title: "Antrag - Geschwindigkeit | Legalbird",
    stepUrl: "gefahrene-geschwindigkeit",
    applicationStatus: APPLICATION_STATUS_SPEED,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"accusation"} progress={40} />
        <DistanceSpeed {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_DISTANCE]: {
    title: "Antrag - Abstand | Legalbird",
    stepUrl: "abstand",
    applicationStatus: APPLICATION_STATUS_DISTANCE,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"accusation"} progress={45} />
        <Distance {...props} />
      </>
    ),
  },
  //-- other
  [APPLICATION_STATUS_ACCUSATION_OTHER]: {
    title: "Antrag - Sonstiges | Legalbird",
    stepUrl: "sonstiges",
    applicationStatus: APPLICATION_STATUS_ACCUSATION_OTHER,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"accusation"} progress={40} />
        <AccusationOther {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_VEHICLE]: {
    title: "Antrag - Fahrzeug | Legalbird",
    stepUrl: "fahrzeug",
    applicationStatus: APPLICATION_STATUS_VEHICLE,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"accusation"} progress={45} />
        <MobileVehicle {...props} />
      </>
    ),
  },

  [APPLICATION_STATUS_DRIVERS_LICENSE_PERIOD]: {
    title: "Antrag - Führerschein | Legalbird",
    stepUrl: "fuehrerschein",
    applicationStatus: APPLICATION_STATUS_DRIVERS_LICENSE_PERIOD,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"driver"} progress={50} />
        <DriversLicensePeriod {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_FLENSBURG_POINTS]: {
    title: "Antrag - Punkte | Legalbird",
    stepUrl: "punkte",
    applicationStatus: APPLICATION_STATUS_FLENSBURG_POINTS,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"driver"} progress={55} />
        <Flensburg {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_FLASHED]: {
    title: "Antrag - Geblitzt | Legalbird",
    stepUrl: "geblitzt",
    applicationStatus: APPLICATION_STATUS_FLASHED,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"driver"} progress={60} />
        <Flashed {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_DRIVERS_LICENSE_INDISPENSABLE]: {
    title: "Antrag - Führerschein angewiesen | Legalbird",
    stepUrl: "angewiesen",
    applicationStatus: APPLICATION_STATUS_DRIVERS_LICENSE_INDISPENSABLE,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"driver"} progress={65} />
        <Indispensable {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_LEGAL_INSURANCE]: {
    title: "Antrag - Rechtsschutz | Legalbird",
    stepUrl: "rechtsschutz",
    applicationStatus: APPLICATION_STATUS_LEGAL_INSURANCE,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"driver"} progress={65} />
        <Insurance {...props} withDeductible />
      </>
    ),
  },
  [APPLICATION_STATUS_PERSONAL_DATA]: {
    title: "Antrag - Persönliche Angaben | Legalbird",
    stepUrl: "persoenliche-angaben",
    applicationStatus: APPLICATION_STATUS_PERSONAL_DATA,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"personal"} progress={75} />
        <Petitioner {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_DOCUMENT_CHOICE]: {
    title: "Antrag - Dokumente | Legalbird",
    stepUrl: "dokumente-auswahl",
    applicationStatus: APPLICATION_STATUS_DOCUMENT_CHOICE,
    render: (props) => <DocumentChoice {...props} />,
  },
  [APPLICATION_STATUS_DOCUMENTS]: {
    title: "Antrag - Dokumente hochladen | Legalbird",
    stepUrl: "dokumente",
    applicationStatus: APPLICATION_STATUS_DOCUMENTS,
    render: (props) => <Documents {...props} />,
  },
  [APPLICATION_STATUS_POWER_OF_ATTORNEY]: {
    title: "Antrag - Vollmacht | Legalbird",
    stepUrl: "vollmacht",
    applicationStatus: APPLICATION_STATUS_POWER_OF_ATTORNEY,
    render: (props) => <PowerOfAttorney {...props} />,
  },
  [APPLICATION_STATUS_DONE]: {
    stepUrl: "done",
    applicationStatus: APPLICATION_STATUS_DONE,
    render: (props) => <Navigate to={getCaseLink(props.product)} />,
  },
};

export default formSteps;
